<template>
<div class="confirmbox">
    <smallbutton :toplabel="title" @click="Show()" v-if="showButton" :disabled="disabled" :buttonclass="buttonclass"/>
    <linkbutton :toplabel="title" @click="Show()" v-if="showLink" :disabled="disabled"/>
    <removebutton @click="Show()" v-if="showImageButton" :disabled="disabled"/>

    <!-- MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            
            <label class="titlelabel">{{title}}</label>

            <div v-if="cartItems.length>1">
                <label :class="textclass">{{body}}</label>
            </div>
            <div v-if="cartItems.length>1">
                <optionbuttonmulti :itemList="cartItems"  @select="selectitem"/>
            </div>
            
            <div>
                <label :class="textclass">Please select a reason for the items that will NOT be returned to stock</label>
            </div>
            <div>

                <div class="" v-if="reasonList.length>1">
                    
                    <select name="" id="" class='filterselect2' v-model="reason"  >
                        <option v-for="i in reasonList" :key="i.Name" :value="i.Name" >
                            {{i.Name}}
                        </option>
                    </select>
                </div>
                <smallbutton  @click="CloseWithReason" toplabel="OK"/>
           
                
            </div>
            <div>
              <label class="responsemessage">{{responseMessage}}</label>
            </div>
        </template>
      </actionmodal>
    </div>
</template>

<script>
import smallbutton from '../controls/button.vue'
import actionmodal from '../controls/actionmodal.vue'
import linkbutton from '../controls/linkbutton.vue'
import removebutton from '../controls/removebutton.vue'
import optionbuttonmulti from '../controls/optionbuttonmulti.vue'
import pay from '../../services/pay.js'
import pos from '../../services/pos.js'
export default {
    name:'confirmrefundvsreturn',
    components:{
        smallbutton,
        actionmodal,
        linkbutton,
        removebutton,
        optionbuttonmulti
    },
    mixins:[pay,pos],
    props:{
        title:{
            type:String,
            default:'Return'
        },
        body:{
            type:String,
            default:'Click to select the items that you WILL return to stock'
        },
        showButton:{
            type:Boolean,
            default:false
        },
        showImageButton:{
            type:Boolean,
            default:false,
        },
        showLink:{
            type:Boolean,
            default:false
        },
        disabled:{
          type:Boolean,
          default:false
        },
        buttonclass:{
            type:String,
            default:"button primarybutton"
        },
        isAlert:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            responseMessage:'',
            reasonList:[],
            reason:null,
            isrefund:false
        }
    },
    computed:{
    
        textclass(){
            if(this.isAlert){return 'required'}
            else{return ''}
        },
        
    },
    methods:{
        
        Show(){
            this.getreasons()
            this.$refs.mymodal.openModal()
        },
        selectitem(id,name){
            var i
            for (i = 0; i <= this.cartItems.length - 1; i++) {
                var islast = i==this.cartItems.length-1
                //if NOT selected, run it as a refund
                if(this.cartItems[i].id==id){
                   this.cartItems[i].selected=!this.cartItems[i].selected 
                   console.log(this.cartItems[i].name + ' ' + this.cartItems[i].selected)
                }
                
            }

        },
        async CloseWithReason(){
            var i;
            for (i = 0; i <= this.cartItems.length - 1; i++) {
                var islast = i==this.cartItems.length-1
                //if NOT selected, run it as a refund
                if(!this.cartItems[i].selected){
                    await this.returnitem(this.cartItems[i].lineItemId,islast,false)
                }
                
            }



            if(this.reason==null || this.reason=='<Select Reason>'){
                this.responseMessage="Please select a reason"
                return
            }
            this.$emit('savereason', this.reason)
            this.$refs.mymodal.closeModal()
        },
        
    },
    mounted(){
        
    }
}
</script>

<style>
.filterselect2{
    width:200px;
    font:inherit;
    margin:10px;

}
.confirmbox{
    color:black;
}
</style>